import { ActionModal } from '@atoms/Modals';
import format from 'date-fns/format';
import React from 'react';
import { CSVLink } from 'react-csv';
import styled from 'styled-components';

type Columns = {
    label: string;
    key: string;
};

type Props = {
    listData?: any;
};

const closeApplyColumn: Columns[] = [
    { label: '契約コード', key: 'contactId' },
    { label: '申込書番号', key: 'requestNo' },
    { label: '供給地点特定番号', key: 'powerCustomerLocationNumber' },
    { label: '状態', key: 'acceptStatusName' },
    { label: '解約理由', key: '' },
    { label: '解約日', key: 'supplyEndDate' },
    { label: '履歴コメント', key: 'information' }
];

const CsvDownloadClose = (props: Props) => {
    const fileNameDate = `swiching_close_list_${format(new Date(), 'yyyyMMdd_HHmmss')}`;
    const { listData } = props;
    const { data, error, loading } = listData;
    const closeRequestListData = data || [];

    return (
        <CsvDownloadWithStyled>
            {loading && ''}
            {error && ''}
            {data &&
                <ActionModal
                    title='廃止 一覧ダウンロード'
                    body='廃止 一覧をダウンロードします。よろしいですか？'
                    buttonText='CSVダウンロード(廃止)'
                    buttonStyle='btn-primary'
                    element={<CSVLink className='btn btn-primary' filename={fileNameDate} headers={closeApplyColumn} data={closeRequestListData}>はい</CSVLink>}
                    disabled={!closeRequestListData.length}
                />
            }
        </CsvDownloadWithStyled>
    );
};

const CsvDownloadWithStyled = styled.div`
`

export default CsvDownloadClose;